<template>
  <h2 class="subtitle has-text-centered store-name">
    <button
      v-if="!vendingsOnly"
      class="button is-small is-rounded is-pulled-left store-type-button"
      :class="{
        'is-smart-orange':
          type === 'market' ||
          type === 'marketRoom' ||
          type === 'marketAquarium',
        'is-deep-purple': type === 'station',
        'is-elegant-black': type === 'box',
        'is-warning': type === 'dc',
        'is-light': type === 'vending' || type === 'locker'
      }"
    >
      {{
        type === "market" || type === "marketRoom" || type === "marketAquarium"
          ? "Market"
          : type === "station"
          ? "Station"
          : type === "box"
          ? "Box"
          : type === "vending"
          ? "Vending"
          : type === "locker"
          ? "Locker"
          : type === "dc"
          ? "Centro de Distribuição"
          : "-"
      }}
    </button>

    {{ name }}
    <hr style="margin: 0.7rem 0;" />
  </h2>
</template>

<script>
export default {
  props: ["type", "name", "vendingsOnly"]
};
</script>

<style scoped>
@media (max-width: 768px) {
  .store-name {
    margin-top: 0.3rem;
    margin-bottom: 1.5rem;
  }
}
.store-type-button {
  cursor: default;
}
</style>
